module.exports = __webpack_public_path__ + "static/media/beer-fail.d9838ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beer-fail.jpg
// module id = 117
// module chunks = 0